<template>
  <div class="home">
    <div class="cropper">
      <vueCropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.outputSize"
          :outputType="option.outputType"
          :canScale='option.canScale'
          :autoCrop='option.autoCrop'
          :autoCropWidth='option.autoCropWidth'
          :autoCropHeight='option.autoCropHeight'
          :canMoveBox='option.canMoveBox'
          :canMove='option.canMove'
          :centerBox='option.centerBox'
          :info='option.info'
          :fixedBox='option.fixedBox'
      ></vueCropper>
    </div>
    <Button type='primary' @click='handleClick' style="width: 100%;margin-top: 10px">确 定</Button>
  </div>
</template>

<script>
import {VueCropper} from 'vue-cropper'
import {Button} from "mint-ui";

export default {
  data() {
    return {
      option: {
        img: null,
        outputSize: 1, // 裁剪生成图片质量
        outputType: 'jepg', // 裁剪生成图片格式
        canScale: true, // 图片是否允许滚轮播放
        autoCrop: true, // 是否默认生成截图框 false
        info: false, // 是否展示截图框信息
        autoCropWidth: 240, // 生成截图框的宽度
        autoCropHeight: 240, // 生成截图框的高度
        canMoveBox: false, // 截图框是否可以拖动
        fixedBox: true, // 固定截图框的大小
        canMove: true, // 上传图片是否可拖动
        centerBox: true, // 截图框限制在图片里面
      },
    }
  },
  components: {
    VueCropper,
    Button
  },
  methods: {
    handleClick() {
      this.$refs.cropper.getCropData(data => {
        this.$router.replace({name: 'm_myinfo', params: {avatar: data}});
      })
    }
  },
  mounted() {
    if (this.$route.params.avatar === undefined) {
      this.$router.replace('/m_birthday')
      return
    }
    this.option.img = this.$route.params.avatar
  }
}
</script>

<style lang="less" scoped>
@color: #333;
.home {
  width: 100%;
  height: 100%;
  background-color: #eee;

  .cropper {
    width: 100%;
    height: 400px;
    border: 1px solid orange;
  }
}
</style>
